export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/MX-a648480d8859ee53dbdd0a266695f81f.png";